import React, { useState } from 'react'
import { twMerge } from 'tailwind-merge'
import { Waypoint } from 'react-waypoint'

interface ModalProps {
  children: JSX.Element
  close: () => void
  className?: string
}

const Modal = ({ children, close, className }: ModalProps) => {
    const [isVisible, setIsVisible] = useState(false)
    return (
        <Waypoint onEnter={() => setIsVisible(true)}>
            <div
                onClick={close}
                className={twMerge('fixed z-40 bg-black/20 w-screen h-screen top-0 left-0')}
            >
                <div className='pointer-events-auto flex items-center justify-center h-full'>
                    <div
                        style={{
                            transform: isVisible ? 'translateY(0px)' : 'translateY(40px)',
                            opacity: isVisible ? '1' : '0',
                        }}
                        className={twMerge('transition duration-500', className)}
                        onClick={(e) => {
                            e.stopPropagation()
                        }}
                    >
                        {children}
                    </div>
                </div>
            </div>
        </Waypoint>
    )
}

export default Modal
